import React from 'react'
import { IconeAlvo, IconeConversa, IconeCalculadora, IconeBarras } from '../lib/icones'
import { ASSINATURA_ROTA } from '../dados/evento'

const ICONES = {
  alvo: IconeAlvo,
  conversa: IconeConversa,
  calculadora: IconeCalculadora,
  barras: IconeBarras,
}

/**
 * Assinatura da Rota — a faixa "Menos atrito · Mais clareza · Mais eficiência ·
 * Melhores resultados", cada frase com seu ícone.
 *
 * POR QUE ELA É UM COMPONENTE, e não um enfeite de uma dobra só: é o elemento
 * MAIS repetido da identidade do evento. Está no fundo de palco, no totem de
 * credenciamento, no display de mesa, na sacola, no crachá, no caderno e em
 * todas as lâminas do deck de patrocínio. Era a peça que faltava na landing —
 * e é justamente o que costura a página às coisas que a pessoa vai ver ao
 * vivo, no dia.
 *
 * Aparece duas vezes na página, com a mesma marcação e pesos diferentes:
 * abaixo do hero (`variante="hero"`, mais alta e luminosa, fechando a 1ª
 * dobra) e no rodapé (padrão, discreta). Uma terceira aparição dilui.
 *
 * `aria-hidden` NÃO entra aqui: são quatro promessas do evento, conteúdo real
 * — só os ícones são decorativos, e cada um já vem com `aria-hidden` próprio.
 */
export default function AssinaturaRota({ variante = 'padrao', className = '' }) {
  return (
    <ul className={`assinatura assinatura-${variante} ${className}`.trim()}>
      {ASSINATURA_ROTA.map(({ texto, icone }) => {
        const Icone = ICONES[icone] || IconeAlvo
        return (
          <li key={texto} className="assinatura-item">
            <span className="assinatura-icone" aria-hidden="true">
              <Icone />
            </span>
            {texto}
          </li>
        )
      })}
    </ul>
  )
}
